import { useEffect, useState, type ReactNode } from 'react'
import { ButtonLink, LoadingState } from 'admination-react'
import { redeemRegistrationLink } from '@/core/api/auth'
import { ApiError, setActiveOrganisationId } from '@/core/api/http'
import { resetMe } from '@/core/data/session'
import { useAuth } from '@/core/state/auth'
import { LOGIN_FAILED, REGISTRATION_LINK_INVALID, tooManyAttemptsMessage } from './messages'

export function RegistrationLink({ token, children }: { token: string | null; children: ReactNode }) {
  const { loading, session, refresh } = useAuth()
  const [redeemedUser, setRedeemedUser] = useState<string | null>(null)
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(token ? null : REGISTRATION_LINK_INVALID)

  useEffect(() => {
    if (loading || !token) return
    setActiveOrganisationId(null)
    let active = true
    void redeemRegistrationLink(token).then(async (identity) => {
      resetMe()
      await refresh()
      return identity.user_id
    }).then((userId) => {
      if (active) setRedeemedUser(userId)
    }).catch((err: unknown) => {
      if (!active) return
      setError(tooManyAttemptsMessage(err) ??
        (err instanceof ApiError && err.status === 401 ? REGISTRATION_LINK_INVALID : LOGIN_FAILED))
    })
    return () => { active = false }
  }, [loading, token, refresh])

  const signedIn = redeemedUser !== null && session?.scope === 'staff' && session.user_id === redeemedUser
  useEffect(() => {
    if (signedIn) {
      window.history.replaceState(window.history.state, '', '/')
      setDone(true)
    }
  }, [signedIn])

  if (done || signedIn) return children
  const failure = error ?? (redeemedUser !== null ? LOGIN_FAILED : null)
  return (
    <div className="page" id="page">
      <div className="layout layout--center" id="base-layout">
        <main className="form form--narrow">
          {failure ? (
            <div className="section">
              <h3 className="section-header">Anmeldung</h3>
              <div className="section-body">
                <p role="alert" className="field-error">{failure}</p>
                <ButtonLink block href="/">Zur Anmeldung</ButtonLink>
              </div>
            </div>
          ) : <LoadingState>Sie werden angemeldet …</LoadingState>}
        </main>
      </div>
    </div>
  )
}
